import type {
  Scene,
  SceneObjectFromAPI,
  SceneSettingsFromAPI,
} from '../types';
import apiRequest from './apiRequest';

export type UpdateSceneRequest = {
  sceneName?: string;
  sceneSettings?: SceneSettingsFromAPI;
  sceneSettingsID?: string;
  objects?: Record<string, SceneObjectFromAPI>;
};

export default async function putExternalScene(
  apiKey: string,
  sceneID: string,
  sceneRequest: UpdateSceneRequest,
) {
  return await apiRequest<Scene>(
    'external-mogen',
    `/scenes/${encodeURIComponent(sceneID)}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
      body: JSON.stringify(sceneRequest),
    },
  );
}
